import React from 'react'

import type { IconProps } from './types'

const Doctor: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_896_117592)">
        <path
          d="M38.111 41.19c-.855-1.316-3.277-4.196-7.631-6.105l-.008-.008a7.978 7.978 0 0 0-3.082-1.803 4.83 4.83 0 0 0-.233-.416l-.078-.128a3.576 3.576 0 0 1-6.143 0 7.18 7.18 0 0 0-.307.533c-.004.003-.004.007-.008.01a7.963 7.963 0 0 0-3.079 1.804l-.007.008c-4.354 1.909-6.78 4.789-7.631 6.105-.994 1.538-.075 2.37 1.35 3.131 1.008.537 3.255 1.538 6.877 2.111v.004c.78.124 1.624.229 2.531.3a39.252 39.252 0 0 0 3.345.139 39.064 39.064 0 0 0 3.345-.139 32.18 32.18 0 0 0 2.532-.3v-.004c3.622-.573 5.868-1.575 6.877-2.11 1.425-.762 2.344-1.595 1.35-3.132Z"
          fill="#F4F6FF"
        />
        <path
          d="M36.266 18.84a2.876 2.876 0 0 1 .465 2.932c-.536 1.433-2.231 2.517-3.668 1.992-.59-1.628-.24-4.065.672-4.827 1-.761 1.843-.597 2.531-.097Zm-9.188 13.89a3.576 3.576 0 0 1-6.142 0c.139-.346.24-.705.3-1.073a8.42 8.42 0 0 0 .105-.91v-.053c.008.003 5.317-.042 5.325-.045l.008.097c.018.315.052.6.093.859.058.359.152.71.282 1.05.01.026.018.052.03.075Z"
          fill="#FF7364"
        />
        <path
          d="M28.245 36.199c-.012-.094-.027-.184-.042-.278a9.228 9.228 0 0 0-.813-2.647 4.83 4.83 0 0 0-.233-.416c-.022-.038-.049-.08-.079-.128a3.577 3.577 0 0 1-6.142 0 7.18 7.18 0 0 0-.308.533c-.003.003-.003.007-.007.01a9.583 9.583 0 0 0-.859 2.952c-.592 4.148.54 9.304.9 10.511a39.248 39.248 0 0 0 3.345.139 39.06 39.06 0 0 0 3.345-.139c.36-1.211 1.497-6.386.893-10.537Z"
          fill="#F7F9FC"
        />
        <path
          d="M14.405 18.965c.583.441 1.93 3.77.543 4.8-1.437.525-3.132-.559-3.668-1.991a2.877 2.877 0 0 1 .465-2.933c.974-.56 1.955-.558 2.66.124Z"
          fill="#FF7364"
        />
        <path
          d="M24.833 37.796c.4-.306.727-.699.957-1.148-.72-.513-1.024-1.327-1.782-1.327-.806 0-1.407 1.06-1.767 1.319v.031c.226.441.548.825.942 1.125-.84 2.374-1.534 6.9-1.534 9.012.746.045 1.532.067 2.359.067.826 0 1.61-.022 2.355-.067 0-2.112-.694-6.638-1.53-9.012Z"
          fill="#5166F1"
        />
        <path
          d="M25.79 36.648c-.23.45-.557.842-.957 1.148a1.38 1.38 0 0 1-1.65 0 3.31 3.31 0 0 1-.942-1.125v-.031c.36-.259.96-1.32 1.767-1.32.758 0 1.062.815 1.782 1.328Z"
          fill="#473049"
        />
        <path
          d="M28.204 35.921a9.228 9.228 0 0 0-.814-2.647 12.5 12.5 0 0 0-.311-.544 3.576 3.576 0 0 1-6.143 0 12.5 12.5 0 0 0-.311.544 9.228 9.228 0 0 0-.814 2.647 60.71 60.71 0 0 0-.123.94c.165.274 1.444.557 2.557-.19.36-.272.695-.574 1.005-.901.123-.118.26-.22.408-.303a.811.811 0 0 1 .697 0c.148.084.285.185.408.303.31.327.646.628 1.006.9 1.113.746 2.392.464 2.557.19-.014-.13-.107-.845-.122-.939Z"
          fill="#36B1F2"
        />
        <path
          d="M18.127 37.77c-.176.037-2.208.495-2.1.045.206-1.045.733-2 1.508-2.73l.007-.008a7.963 7.963 0 0 1 3.08-1.804c-2.093 4.14-.413 11.94.04 13.463a32.18 32.18 0 0 1-2.53-.3v-.004c-.477-.592-1.767-3.202-2.13-6-.083-.615.505-1.792 2.125-2.662Zm11.76 0c1.62.87 2.21 2.047 2.127 2.662-.364 2.798-1.654 5.408-2.13 6v.004c-.78.124-1.624.229-2.532.3.454-1.523 2.134-9.323.038-13.463a7.992 7.992 0 0 1 3.082 1.804l.008.008a5.112 5.112 0 0 1 1.508 2.73c.108.45-1.924-.008-2.1-.045Z"
          fill="#939FF2"
        />
        <path
          d="M28.204 35.921a9.228 9.228 0 0 0-.814-2.647 12.5 12.5 0 0 0-.311-.544 3.576 3.576 0 0 1-6.143 0 12.5 12.5 0 0 0-.311.544 9.228 9.228 0 0 0-.814 2.647 60.71 60.71 0 0 0-.123.94c.165.274 1.444.557 2.557-.19.36-.272.695-.574 1.005-.901.123-.118.26-.22.408-.303a.811.811 0 0 1 .697 0c.148.084.285.185.408.303.31.327.646.628 1.006.9 1.113.746 2.392.464 2.557.19-.014-.13-.107-.845-.122-.939Z"
          fill="#E4E8EC"
        />
        <path
          d="M26.768 31.605a5.08 5.08 0 0 1-2.802.791 5.132 5.132 0 0 1-2.73-.739c.052-.301.087-.605.105-.91v-.053c.008.003 5.318-.042 5.325-.045l.008.097c.019.315.052.6.094.859Z"
          fill="#ED4850"
        />
        <path
          d="M33.735 18.938a36.91 36.91 0 0 1-.671 4.826c-.878 3.84-3.791 6.045-6.394 6.975-.007.003-.015.003-.022.007a8.082 8.082 0 0 1-2.64.529 8.102 8.102 0 0 1-2.644-.529l-.019-.007c-2.602-.93-5.52-3.131-6.397-6.975a36.903 36.903 0 0 1-.672-4.778c.654-4.267 3.35-14.017 13.146-11.491 3.44.887 4.76 4.224 6.313 8.677.193.553 0 2.243 0 2.765Z"
          fill="#FF977B"
        />
        <path
          d="M24.007 22.71c-.01 0-1.087-.027-1.087-.626a.375.375 0 0 1 .69-.203c.255.105.54.105.794 0a.376.376 0 0 1 .69.203c0 .599-1.076.626-1.087.626Zm.001 2.685c-.727 0-1.29-.282-1.507-.755a.375.375 0 1 1 .682-.312c.067.146.323.317.825.317.501 0 .754-.171.821-.317a.374.374 0 0 1 .696.023.376.376 0 0 1-.014.29c-.216.472-.778.754-1.503.754Z"
          fill="#ED4850"
        />
        <path
          d="M27.346 36.733a1.882 1.882 0 0 1-1.358-.367 5.112 5.112 0 0 1-.637-.57c-.384-.385-.78-.782-1.344-.782-.43.03-.83.228-1.113.552-.08.075-.159.155-.241.238a5.361 5.361 0 0 1-.598.541.484.484 0 0 0-.031.02 1.878 1.878 0 0 1-1.356.368.366.366 0 0 0-.41.338.375.375 0 0 0 .338.41 2.643 2.643 0 0 0 1.867-.506c.257-.194.498-.408.72-.642.075-.078.15-.152.228-.225.626-.6.821-.375 1.408.215.225.238.47.456.732.652a2.641 2.641 0 0 0 1.868.503.375.375 0 0 0-.075-.747l.002.002Z"
          fill="#D2D6DC"
        />
        <path
          d="M41.063 35.63a1.979 1.979 0 0 1-3.957 0 2.006 2.006 0 0 1 1.978-1.98 1.91 1.91 0 0 1 1.979 1.98Z"
          fill="#78C5EF"
        />
        <path
          d="M39.082 37.983a2.357 2.357 0 0 1-2.354-2.353 2.387 2.387 0 0 1 2.34-2.354 2.227 2.227 0 0 1 1.658.627 2.363 2.363 0 0 1 .71 1.728 2.363 2.363 0 0 1-2.354 2.352Zm.077-3.958h-.062a1.64 1.64 0 0 0-1.619 1.604 1.605 1.605 0 1 0 2.727-1.188c-.28-.27-.656-.42-1.046-.416Z"
          fill="#CAE7EF"
        />
        <path
          d="M28.415 44.465a4.789 4.789 0 0 1-4.784-4.784v-6.024a.375.375 0 0 1 .75 0v6.024a4.034 4.034 0 0 0 8.068 0v-6.995a3.504 3.504 0 0 1 7.008 0v2.916a.375.375 0 0 1-.75 0v-2.916a2.754 2.754 0 0 0-5.508 0v6.995a4.789 4.789 0 0 1-4.784 4.784Z"
          fill="#1B89E5"
        />
        <path
          d="M23.288 32.413v.62a.646.646 0 0 0 .375.544.78.78 0 0 0 .688 0 .646.646 0 0 0 .375-.544v-.62h-1.438Z"
          fill="#269BEA"
        />
        <path
          d="M24.008 34.032c-.178 0-.354-.041-.513-.12a1.024 1.024 0 0 1-.582-.879v-.62a.375.375 0 0 1 .75 0v.62a.284.284 0 0 0 .167.209.436.436 0 0 0 .352 0 .283.283 0 0 0 .168-.208v-.621a.375.375 0 0 1 .75 0v.62a1.024 1.024 0 0 1-.582.88 1.171 1.171 0 0 1-.51.12Z"
          fill="#269BEA"
        />
        <path
          d="M19.22 23.276a3.65 3.65 0 1 0 0-7.298 3.65 3.65 0 0 0 0 7.298Zm9.646 0a3.649 3.649 0 1 0 0-7.298 3.649 3.649 0 0 0 0 7.298Z"
          fill="#FFB19F"
        />
        <path
          d="M16.613 14.854a6.019 6.019 0 0 1 4.642-.727.674.674 0 0 1 .476.754.675.675 0 0 1-.72.576c-.828-.065-2.305-.118-3.334.196-.77.234-1.099.07-1.237-.15a.487.487 0 0 1 .173-.649Zm14.787 0a6.02 6.02 0 0 0-4.643-.727.675.675 0 0 0-.476.754.675.675 0 0 0 .721.576c.828-.065 2.305-.118 3.334.196.77.234 1.098.07 1.237-.15a.487.487 0 0 0-.173-.649Z"
          fill="#473049"
        />
        <path
          d="M18.578 19.395a.892.892 0 1 0 1.784 0v-.735a.892.892 0 1 0-1.784 0v.735Zm10.856-.735a.892.892 0 1 0-1.784 0v.735a.892.892 0 1 0 1.784 0v-.735Z"
          fill="#4B3956"
        />
        <path
          d="M20.752 18.784a.375.375 0 0 1-.375-.375c0-.362-.495-.679-1.06-.679-.566 0-1.062.317-1.062.679a.375.375 0 1 1-.75 0c0-.788.813-1.429 1.811-1.429.999 0 1.811.64 1.811 1.429a.375.375 0 0 1-.375.375Zm9.379 0a.375.375 0 0 1-.375-.375c0-.362-.496-.679-1.061-.679s-1.061.317-1.061.679a.375.375 0 1 1-.75 0c0-.788.812-1.429 1.811-1.429.999 0 1.811.64 1.811 1.429a.375.375 0 0 1-.375.375Z"
          fill="#473049"
        />
        <path
          d="M28.866 15.602a4.03 4.03 0 0 0-3.937 3.2h-1.77a4.024 4.024 0 1 0 .086.825c0-.025-.003-.05-.004-.075h1.606c0 .025-.004.05-.004.075a4.024 4.024 0 1 0 4.023-4.024Zm-9.647 7.3a3.275 3.275 0 1 1 0-6.55 3.275 3.275 0 0 1 0 6.55Zm9.647 0a3.275 3.275 0 1 1 0-6.551 3.275 3.275 0 0 1 0 6.55Z"
          fill="#fff"
        />
        <path
          d="M34.924 6.052c6.705 2.51 7.26 11.172 1.342 12.788a5.27 5.27 0 0 1-2.53.097 5.079 5.079 0 0 1-1.49-.592c-4.706-2.768-2.816-7.976-5.73-10.013-2.602-1.818-5.966.743-6.187 4.1-.176 2.617-2.606 6.03-6.053 6.554a6.07 6.07 0 0 1-2.53-.146 9.53 9.53 0 0 1-.74-.251c-4.863-1.79-4.42-9.402 2.404-13.294 5.115-2.921 9.435-5.171 13.91-3.716s3.934 3.1 7.605 4.473Z"
          fill="#4B3956"
        />
        <path
          d="M24 32.814c-6 0-10.88-5.117-10.88-11.407 0-.206.137-.605.344-.605.208 0 .425.07.425.277 0 6.583 5.239 10.985 10.11 10.985 4.872 0 10.117-4.474 10.117-11.056 0-.207.22-.125.428-.125.207 0 .335.318.335.525 0 6.289-4.88 11.406-10.88 11.406Z"
          fill="#1B89E5"
        />
        <path
          d="M13.31 21.622h-.688a.74.74 0 1 1 0-1.478h.383a.89.89 0 0 1 .891.891.587.587 0 0 1-.586.587Zm21.697-1.477h.384a.74.74 0 1 1 0 1.478h-.688a.587.587 0 0 1-.587-.587.891.891 0 0 1 .891-.891Z"
          fill="#544587"
        />
      </g>
      <defs>
        <clipPath id="clip0_896_117592">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Doctor
